<template>
  <el-upload
    :class="{'upload-files': true, 'upload-readonly': readOnly}"
    list-type="picture-card"
    :accept="accept"
    :action="uploadUrl"
    :headers="headers"
    :disabled="readOnly"
    :multiple="multiple"
    :limit="limit"
    :before-upload="beforeFileUpload"
    :on-success="fileUploadSuccess"
    :on-exceed="fileUploadExceed"
    :on-error="fileUploadError"
    :file-list="showFileList">
    <i slot="default" class="el-icon-plus"></i>
    <div slot="file" slot-scope="{file}">
      <img v-if="file.isImg && !readOnly" class="image" :src="file.url" alt="">
      <el-image
        v-if="file.isImg && readOnly"
        :src="file.url"
        class="image"
        fit="contain"
        :preview-src-list="[file.url]">
      </el-image>
      <div v-if="!file.isImg" class="doc">
        <i class="el-icon-document doc-icon"></i>
        <div class="doc-name">{{file.name}}</div>
      </div>
      <span class="el-upload-list__item-actions" v-if="file.isImg && !readOnly">
        <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
          <i class="el-icon-zoom-in"></i>
        </span>
        <span class="el-upload-list__item-delete" @click="handleRemove(file)">
          <i class="el-icon-delete"></i>
        </span>
      </span>
      <span class="el-upload-list__item-actions" v-if="!file.isImg">
        <span class="el-upload-list__item-delete" @click="handleDownload(file)">
          <i class="el-icon-download"></i>
        </span>
        <span v-if="!readOnly" class="el-upload-list__item-delete" @click="handleRemove(file)">
          <i class="el-icon-delete"></i>
        </span>
      </span>
    </div>
    <div v-if="!readOnly" slot="tip" class="el-upload__tip">最多上传{{limit}}个文件</div>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <el-image
        :src="dialogImageUrl"
        style="height: 70vh;display:flex"
        fit="contain"
        :preview-src-list="[dialogImageUrl]">
      </el-image>
    </el-dialog>
  </el-upload>
</template>

<script>
import {getToken} from "@/utils/auth";

export default {
  name: "fileUpload",
  props: {
    uploadPath: {
      type: String,
      default: '/upload/'
    },
    accept: {
      type: String
    },
    value: {},
    limit: {
      type: Number,
      default () {
        return 5
      }
    },
    readOnly: {
      type: Boolean,
      default () {
        return false
      }
    },
    multiple: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data() {
    return {
      fileObjs:  this.value || [],
      uploadUrl: null,
      headers: {},
      addFilePopVisible: false,
      dialogImageUrl: '',
      dialogVisible: false,
      loading: null,
      showFileList:[],
      uploading:false,
      pendingUploadIds: []
    };
  },
  created() {
    this.uploadUrl = process.env.VUE_APP_BASE_API + this.uploadPath
    this.headers = {'Authorization': getToken(), 'Terminal-Type': 'PC', platform: 'pc'}
    this.copyFileObjs()
  },
  watch: {
    value (val) {
      this.fileObjs = this.value || []
      this.copyFileObjs();
    }
  },
  methods: {
    beforeFileUpload (file) {
      let fileM = file.size / 1024 / 1024;
      if(fileM > 100){
        this.msgWarning('上传文件大小不能超过100M');
        return false;
      }
      if (this.accept && !this.isAcceptedFile(file)) {
        this.msgWarning(this.isImageOnlyAccept() ? '只能上传图片文件' : '文件类型不符合要求');
        return false;
      }
      this.pendingUploadIds.push(file.uid)
      this.$emit('uploading-change', true)
      this.loading = this.$loading({lock: true, text: '上传中', spinner: 'el-icon-loading'})
      return true;
    },
    isImageFile(file) {
      if (!file) {
        return false
      }
      if (file.type && /^image\//i.test(file.type)) {
        return true
      }
      return /\.(png|jpe?g|gif|webp|bmp|svg)(?:[?#]|$)/i.test(file.name || '')
    },
    isImageOnlyAccept() {
      const rules = this.acceptRules()
      return rules.length > 0 && rules.every(rule => rule === 'image/*' || /^image\//i.test(rule))
    },
    acceptRules() {
      return (this.accept || '')
        .split(',')
        .map(item => item.trim().toLowerCase())
        .filter(Boolean)
    },
    isAcceptedFile(file) {
      const rules = this.acceptRules()
      if (!rules.length || !file) {
        return true
      }
      const fileName = (file.name || '').toLowerCase()
      const fileType = (file.type || '').toLowerCase()
      return rules.some(rule => {
        if (rule === '*/*') return true
        if (rule === 'image/*') return this.isImageFile(file)
        if (rule.endsWith('/*')) {
          const prefix = rule.slice(0, rule.length - 1)
          return fileType.indexOf(prefix) === 0
        }
        if (rule.charAt(0) === '.') {
          return fileName.endsWith(rule)
        }
        return fileType === rule
      })
    },
    fileUploadSuccess (response, file, fileList) {
      const uploadedFile = {
        uid: file.uid,
        id: response.id,
        isImg: response.isImg,
        name: response.name,
        url: response.url,
        size: response.size,
        contentType: response.contentType
      }
      this.fileObjs.push(uploadedFile)

      this.uploading=true;
      if(this.fileObjs.length==fileList.length)
      {//showFileList绑定了 file-list 不能改引用，但是可以该改引用对象
        // ，不然多文件上传的时候会只执行一次 :on-success ，-by dns
        this.uploading=false
        this.copyFileObjs()
      }
      this.$emit('input', this.fileObjs)
      this.$emit('on-change', this.fileObjs)
      this.$emit('raw-file-uploaded', {
        rawFile: file && file.raw ? file.raw : null,
        fileInfo: uploadedFile
      })
      this.finishUpload(file)
    },
    fileUploadError(error, file) {
      this.finishUpload(file)
    },
    finishUpload(file) {
      this.pendingUploadIds = this.pendingUploadIds.filter(uid => file && uid !== file.uid)
      const pending = this.pendingUploadIds.length > 0
      this.$emit('uploading-change', pending)
      if (!pending) {
        this.uploading = false
        this.copyFileObjs()
        if (this.loading) this.loading.close()
      }
    },
    fileUploadExceed (file, fileList) {
      this.msgWarning("最多上传" + this.limit + "个文件")
    },
    handleRemove(file, fileList) {
      for (let i = 0; i < this.fileObjs.length; i++) {
        if (this.fileObjs[i].uid === file.uid) {
          this.fileObjs.splice(i, 1);
          i--;
        }
      }
      this.$emit('input', this.fileObjs)
      this.$emit('on-change', this.fileObjs)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      window.open(file.url)
    },
    copyFileObjs(){//将实际操作的fileList复制到展示用的showList上
      if(!this.uploading)//文件上传的时候不执行
      {
        var showArr=this.showFileList
       showArr.splice(0,showArr.length);
        var arr=this.fileObjs;
        for (var i = 0; i < arr.length; i++) {
          showArr.push(arr[i]);
        }
      }
    }
  }
}
</script>

<style lang='scss'>
.upload-readonly {
  .el-upload--picture-card{
    display: none;
  }
}
.upload-files{
  .el-upload-list__item{
    width: 100px;
    height: 100px;
  }
  .el-upload--picture-card{
    width: 100px;
    height: 100px;
    line-height: 100px;
  }
  .el-upload__tip {
    line-height: 14px;
  }
  .image{
    width: 100px;
    height: 100px;
    object-fit: contain;
  }
  .doc{
    text-align: center;
    .doc-icon{
      font-size: 30px;
      padding-top: 15px;
    }
    .doc-name{
      font-weight:500;
      font-size: 12px;
      word-break: break-all;
    }
  }
}
</style>
